import { render, staticRenderFns } from "./ViewTradeModal.vue?vue&type=template&id=36bafed4&scoped=true&"
import script from "./ViewTradeModal.vue?vue&type=script&lang=js&"
export * from "./ViewTradeModal.vue?vue&type=script&lang=js&"
import style0 from "./ViewTradeModal.vue?vue&type=style&index=0&id=36bafed4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bafed4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36bafed4')) {
      api.createRecord('36bafed4', component.options)
    } else {
      api.reload('36bafed4', component.options)
    }
    module.hot.accept("./ViewTradeModal.vue?vue&type=template&id=36bafed4&scoped=true&", function () {
      api.rerender('36bafed4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/transactions/ViewTradeModal.vue"
export default component.exports